// extracted by mini-css-extract-plugin
module.exports = {"title":"CoAuthorsList_title__3Q7P3","list":"CoAuthorsList_list__2HdJG","item":"CoAuthorsList_item___k7N-","authorsSection":"CoAuthorsList_authorsSection__3KGNR"};